import React, { Component } from "react";

class index extends Component {
  render() {
    let { showSidebar } = this.props.parentState;

    return (
      <div
        className={`content`}
        style={{ width: showSidebar ? "82%" : "93%" }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default index;